<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SchemaWebSite',
  computed: {
    ...mapGetters({
      website: 'globalConfig/website'
    }),

    rootUrl() {
      return this.website.domain
        ? `https://${this.website.domain}`
        : 'https://www.sephora.sg'
    }
  },
  render() {
    return this.$slots.default
  },
  jsonld() {
    return {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: this.rootUrl,
      potentialAction: [
        {
          '@type': 'SearchAction',
          target:
            `${this.rootUrl}/search?q={search_term_string}&utm_source=google&utm_medium=organic` +
            '&utm_campaign=googlesitelinkssearch',
          'query-input': 'required name=search_term_string'
        }
      ]
    }
  }
}
</script>
